define('models/passwordReset',["jQuery", "T1", "T1Model"], function ($, T1, T1Model) {
  var PasswordReset = T1Model.extend({
    url: "reset_password",
    minPasswordLength: 3
  });
  T1.Models.PasswordReset = PasswordReset;
  return PasswordReset;
});
